module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMobileSite || _vm.alwaysShow),
      expression: "isMobileSite || alwaysShow"
    }],
    staticClass: "mobile-header",
    style: ({
      paddingTop: _vm.clearHeadPadding ? 0 : _vm.statusBarHeight + 'px'
    })
  }, [_c('div', {
    ref: "fixed",
    staticClass: "fixed",
    style: ([{
        color: _vm.customColor || '',
        background: _vm.customBackgroundColor || '',
        borderBottom: _vm.borderBottom || '1px solid #eee'
      },
      {
        paddingTop: _vm.statusBarHeight + 'px'
      }
    ])
  }, [(!_vm.hideLeft) ? _c('div', {
    staticClass: "header-left"
  }, [(_vm.isCancel) ? [_c('span', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.goBack,
        prevPath: _vm.prevPath
      }),
      expression: "{ methods: goBack, prevPath: prevPath }"
    }],
    staticClass: "cancel-btn"
  }, [_vm._v("取消")])] : (_vm.isCustomText) ? [_c('span', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.goBack,
        prevPath: _vm.prevPath
      }),
      expression: "{ methods: goBack, prevPath: prevPath }"
    }],
    staticClass: "cancel-btn",
    domProps: {
      "innerHTML": _vm._s(_vm.isCustomText)
    }
  })] : (_vm.customOpt && _vm.customOpt.length > 0) ? _vm._l((_vm.customOpt), function(item, index) {
    return _c('v-touch', {
      key: item.icon,
      class: ['yxl-font', ("yxl-font-" + (item.icon))],
      style: ({
        left: ((index * 44) + "px")
      }),
      attrs: {
        "tag": "i"
      },
      on: {
        "tap": item.method
      }
    })
  }) : [_c('i', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.goBack,
        prevPath: _vm.prevPath
      }),
      expression: "{ methods: goBack, prevPath: prevPath }"
    }],
    staticClass: "yxl-font yxl-font-back ic-arrow-left"
  })]], 2) : _vm._e(), _vm._v(" "), [_c('div', {
    staticClass: "head-middle"
  }, [(_vm.navTitle) ? _c('h1', {
    staticClass: "nav-title"
  }, [_vm._v(_vm._s(_vm.navTitle))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], _vm._v(" "), (_vm.optBtn) ? [_c('div', {
    staticClass: "header-right"
  }, [(_vm.$slots.optBtnRight) ? _vm._t("optBtnRight") : _c('v-touch', {
    staticClass: "opt-btn",
    domProps: {
      "innerHTML": _vm._s(_vm.optTxt)
    },
    on: {
      "tap": _vm.headerOpt
    }
  })], 2)] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60711e24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileHeader.vue
// module id = 2552
// module chunks = 115